import { Injectable } from '@angular/core';
import { Loader } from '@googlemaps/js-api-loader';

@Injectable()
export class MapsAPILoader {
  private readonly loader = new Loader({
    apiKey: 'AIzaSyA-ZAjwV7EB0quFqkKZzlz2JWFeAqxhAEY',
    version: 'weekly',
    libraries: ['places']
  });

  private loadPromise: Promise<void> | null = null;

  load(): Promise<void> {
    if (!this.loadPromise) {
      this.loadPromise = this.loader.load().then(() => undefined);
    }
    return this.loadPromise;
  }
}
